import { State } from '~/contracts/common/Geolocation';

export default function maybeIsExcludedLocation({
  isDeliveryAllowed,
  pickUpInfoToDisplay
}: Partial<State>) {
  return Boolean(!isDeliveryAllowed && !pickUpInfoToDisplay);
}
